import script from "./YBLoadingPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./YBLoadingPopup.vue?vue&type=script&setup=true&lang=ts"

import "./YBLoadingPopup.vue?vue&type=style&index=0&id=0fe7b8f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe7b8f0"]])

export default __exports__